import { Badge } from "@/components/ui/badge";

export function CatalogBadges({ badges }: { badges: string[] }) {
	if (badges.length === 0) return null;
	return (
		<div className="mt-auto flex flex-wrap items-center gap-1.5">
			{badges.map((badge) => (
				<Badge
					key={badge}
					variant="secondary"
					className="h-4 shrink-0 px-1.5 py-0 text-[10px]"
				>
					{badge}
				</Badge>
			))}
		</div>
	);
}